<template>
  <div>
    <div>
    <span v-for="(author, index) in authors">
      <span class=""
            v-bind:class="[{ 'underline': (author.role_id == 1 && settings.authors.authorline.underline.author)}]">
        {{ getAuthorName(0, author) }} {{ getAuthorName(1, author) }}</span><span
        v-if="author.role_id == 2">*</span><sup
        v-for="(institute, instindex) in author.institute">{{ institute.affiliation_counter }}<span
        v-if="instindex < author.institute.length-1">,&nbsp;</span></sup><span
        v-if="index < authors.length-1">,&nbsp;</span>
    </span>
      <span v-if="abstract.content__studygroup">, {{ abstract.content__studygroup }}</span>
    </div>
    <div>
      <span v-for="(affiliation, affilindex) in affiliations"><sup>{{ affilindex }}</sup>{{ getInstitute(affiliation) }}<span
          v-if="affilindex < Object.keys(affiliations).length">,&nbsp;</span></span>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'

export default {
  name: "AuthorPreview",
  data() {
    return {};
  },
  created() {
    this.$store.dispatch('GET_AFFILIATIONS', this.$route.params.id);
  },
  methods: {
    ...mapActions([
      'GET_AFFILIATIONS'
    ]),
    getAuthorName(index, author) {
      let type = ["firstname", "lastname"];
      if (this.settings.authors.authorline["order"] && this.settings.authors.authorline["order"].length > 0) {
        type = this.settings.authors.authorline["order"];
      }
      let template = this.settings.authors.authorline[type[index]];
      if (!template.show) {
        return '';
      }
      let name = author[type[index]];
      if (template.cut > 0) {
        name = this.generator(author[type[index]], template.cut);

      }
      if (this.settings.authors.authorline.title && this.settings.authors.authorline.title === true && index === 0 && author['title']) {
        name = author['title'] + ' ' + name;
      }
      if (template.prefix) {
        name = template.prefix + name;
      }
      if (template.suffix) {
        name = name + template.suffix;
      }
      return name;
    },
    getInstitute(affiliation) {
      let institute = [];
      if (affiliation.name) {
        institute.push(affiliation.name);
      }
      if (affiliation.department) {
        institute.push(affiliation.department);
      }
      if (affiliation.city) {
        institute.push(affiliation.city);
      }
      if (affiliation.country_code) {
        institute.push(this.wording[0].country[affiliation.country_code]);
      }
      return institute.join(', ');
    },
    generator(name, length) {
      let finaldata = [];
      let splitSpace = name.split(' ');
      splitSpace.forEach((spacedName) => {
        if (spacedName.search("-") > 0) {
          finaldata.push(this.seperator(spacedName, length));
        } else {
          finaldata.push(this.cutter(spacedName, length))
        }
      });
      return finaldata.join('');
    },
    seperator(name, length) {
      let data = [];
      let splitSeperator = name.split('-');
      splitSeperator.forEach((seperatorName) => {
        data.push(this.cutter(seperatorName, length))
      });
      return data.join('-')
    },
    cutter(name, length) {
      return name.substring(0, length) + '.';
    }
  },
  computed: mapState([
    'authors', 'affiliations', 'wording', 'settings', 'abstract'
  ]),
}
</script>

<style scoped>

</style>
